import { render, staticRenderFns } from "./FabricGeneralDetails.vue?vue&type=template&id=458b7072&scoped=true"
import script from "./FabricGeneralDetails.vue?vue&type=script&lang=js"
export * from "./FabricGeneralDetails.vue?vue&type=script&lang=js"
import style0 from "./FabricGeneralDetails.vue?vue&type=style&index=0&id=458b7072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b7072",
  null
  
)

export default component.exports